import type { IconNode } from '../types';

/**
 * @name layers-arrow-down
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgN3YxNSIgLz4KICA8cGF0aCBkPSJNMiAxMmExIDEgMCAwMC41OC45MWw1LjA5MyAyLjMxNiIgLz4KICA8cGF0aCBkPSJNMjIgMTJhMSAxIDAgMDEtLjU5LjkybC01LjA3NyAyLjMwOCIgLz4KICA8cGF0aCBkPSJNOCAxMC4zNyAyLjYgNy45MWExIDEgMCAwMTAtMS44MzFsOC41Ny0zLjlhMiAyIDAgMDExLjY2LjAwMWw4LjU5IDMuOTFhMSAxIDAgMDEwIDEuODMxbC01LjM5MiAyLjQ1IiAvPgogIDxwYXRoIGQ9Im05IDE5IDMgMyAzLTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/layers-arrow-down
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LayersArrowDown: IconNode = [
  ['path', { d: 'M12 7v15' }],
  ['path', { d: 'M2 12a1 1 0 00.58.91l5.093 2.316' }],
  ['path', { d: 'M22 12a1 1 0 01-.59.92l-5.077 2.308' }],
  [
    'path',
    {
      d: 'M8 10.37 2.6 7.91a1 1 0 010-1.831l8.57-3.9a2 2 0 011.66.001l8.59 3.91a1 1 0 010 1.831l-5.392 2.45',
    },
  ],
  ['path', { d: 'm9 19 3 3 3-3' }],
];

export default LayersArrowDown;
